import React, { useCallback, useEffect } from "react";
import { fromNow } from "helpers/Date";
import { useAuth } from "hooks/Auth";
import { useLocation } from "react-router-dom";
import { apiPost } from "helpers/Request";
import { nonce } from "Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { light } from "@fortawesome/fontawesome-svg-core/import.macro";

function ErrorShell(props) {
    const auth = useAuth();
    const location = useLocation();

    const defaultMessage =
        "Something went wrong. Not entirely sure because the application didn't provide extra info.";

    const logLine =
        (props.message || defaultMessage) +
        " (Path:" +
        location.pathname +
        ", Client:" +
        auth?.publication?.client_code +
        ")";
    const id = nonce();

    const handleError = useCallback(() => {
        apiPost("/v4/log-bridge", auth.publication, {
            message: logLine,
            id: id,
        });
    }, [logLine, id, auth.publication]);

    useEffect(() => {
        handleError();
    }, [handleError]);
    return (
        <div className="mx-auto max-w-full px-4 lg:max-w-lg">
            <div className="mx-auto max-w-full text-center">
                <h1 className="mb-2 text-5xl font-semibold text-green-600">
                    <FontAwesomeIcon icon={light("frown-open")} /> Oh, dang!
                </h1>
                <p className="mb-10 text-sm font-light text-gray-800">
                    That's an error.
                </p>
                <p className="mt-4 text-lg font-light text-gray-800">
                    {props.message ? props.message : defaultMessage}
                </p>
                <div className="mt-10">
                    <div className="mt-4 rounded bg-white p-2 text-left text-sm text-gray-700">
                        <h2 className="mb-2 text-xl font-semibold text-green-600">
                            Still need help?
                        </h2>
                        <p className="mb-4">
                            Providing the following to support can help resolve
                            the problem:
                        </p>
                        <ul className="list-none">
                            <li className="mb-2">Date: {fromNow().toISO()}</li>
                            <li className="mb-2">Message ID: {id}</li>
                        </ul>
                        <div className="mt-4 text-center">
                            <a
                                href="https://support.getsnworks.com"
                                target="_blank"
                                rel="noreferrer noopener"
                                className="focus:outline-none inline-flex justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                            >
                                Contact SNworks Support
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ErrorShell;
